<template>
    <card :noFooterLine="true" class="newsletter-card" @click.native="cardClick">

        <div slot="header">
            <div class="d-flex justify-content-center justify-content-sm-between flex-wrap"> 
                <Badge type="primary">Volume: {{ letter.volume }}</Badge> 
                <Badge type="info">Issue: {{ letter.issue }}</Badge>
            </div>
                <p class="text-muted">{{ date }}</p>
        </div>

        <!-- <div v-if="letter" class="row">
            <div class="col-12">
                <NewsCard type="main" :news="letter.featured_news"></NewsCard>
            </div>
            <div class="col-12" v-for="(item, index) in letter.news" :key="index">
                <NewsCard type="sub" :news="item"></NewsCard>
            </div>
        </div> -->

        <img src="/img/newsletter-preview.png" alt="">
        

        <div slot="footer" class="d-flex justify-content-center justify-content-sm-between flex-wrap">
            <el-tooltip class="item" effect="dark" content="Send Newsletter" placement="bottom">
            <n-button
                v-show="letter.sent != true && letter.draft == false"
                @click.native="actionClick('send')"
                class="send"
                type="info"
                size="sm"
                round
                icon
                simple
            >
                <i class="fa fa-paper-plane"></i>
            </n-button>
            </el-tooltip>
            <el-tooltip class="item" effect="dark" content="Approve Newsletter" placement="bottom">
            <n-button
                v-show="letter.draft == true"
                @click.native="actionClick('approve')"
                class="approve"
                type="success"
                size="sm"
                round
                icon
                simple
            >
                <i class="fa fa-check"></i>
            </n-button>
            </el-tooltip>
            <el-tooltip class="item" effect="dark" content="View Newsletter" placement="bottom">
            <n-button
                @click.native="actionClick('view')"
                class="view"
                type="primary"
                size="sm"
                round
                icon
                simple
            >
                <i class="fa fa-eye"></i>
            </n-button>
            </el-tooltip>
            <el-tooltip class="item" effect="dark" content="Edit Newsletter" placement="bottom">
            <n-button
                @click.native="actionClick('edit')"
                class="edit"
                type="warning"
                size="sm"
                round
                icon
                simple
            >
                <i class="fa fa-pencil"></i>
            </n-button>
            </el-tooltip>
            <el-tooltip class="item" effect="dark" content="Delete Newsletter" placement="bottom">
            <n-button
                @click.native="actionClick('delete')"
                class="remove"
                type="danger"
                size="sm"
                round
                icon
                simple
            >
                <i class="fa fa-times"></i>
            </n-button>
            </el-tooltip>
        </div>

    </card>
</template>

<script>

import { Card, NewsCard, Badge } from 'src/components';
import {Tooltip} from 'element-ui';

export default {
    name: 'NewsletterCard',
    components: {
        Card,
        Badge,
        NewsCard,
        [Tooltip.name]: Tooltip,
    },
    props: {
        letter: Object
    },
    computed: {
        date: function(){
            if(this.letter){
                let date = new Date(this.letter.date)
                return date.toLocaleString('en-US', { year: 'numeric', month: 'long', day: 'numeric' })
            }
            else{
                return ''
            }
        }
    },
    methods: {
        cardClick(){
            this.$emit('card-click', this.letter)
        },
        actionClick(action){
            this.$emit('action-click', this.letter, action)
        }
    }
}
</script>

<style lang="scss">
.newsletter-card{
    .card-header{
        padding: 15px 15px 0;

        .card-title{
            margin-top: 0;
            margin-bottom: 0.25rem;
        }

        p{
            margin-bottom: 0;
            text-align: center;
        }
    }

    .card-body{
        padding-bottom: 0px;
    }

    .card-footer{
        padding: 5px 15px;
        padding-bottom: 15px;
    }
}
</style>
